import React from "react";
import { StatusChipProps } from "../../interfaces/components/statusChip";
import { StatusChipTypes, Status, Priority } from "../../shared/utils/enums";
import { CheckCircle2, Clock, Circle, XCircle, CircleDot, AlertCircle } from "lucide-react";

const StatusChip: React.FC<StatusChipProps> = ({ status, type = "status" }) => {
  const getStatusStyles = () => {
    if (type === StatusChipTypes.priority) {
      switch (status) {
        case Priority.HIGH:
          return "text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800";
        case Priority.MEDIUM:
          return "text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800";
        case Priority.LOW:
          return "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800";
        default:
          return "text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-800";
      }
    } else {
      switch (status) {
        case Status.IN_PROGRESS:
          return "text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950 border-blue-200 dark:border-blue-800";
        case Status.DONE:
          return "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800";
        case Status.TODO:
          return "text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-800";
        case Status.CANCELLED:
          return "text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800";
        case Status.BACKLOG:
          return "text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-950 border-purple-200 dark:border-purple-800";
        case Status.ACTIVE:
          return "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800";
        case Status.ON_LEAVE:
          return "text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800";
        default:
          return "text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-800";
      }
    }
  };

  const getIcon = () => {
    if (type === StatusChipTypes.priority) {
      switch (status) {
        case Priority.HIGH:
          return "↑";
        case Priority.MEDIUM:
          return "→";
        case Priority.LOW:
          return "↓";
        default:
          return "";
      }
    } else {
      switch (status) {
        case Status.IN_PROGRESS:
          return <CircleDot className="w-3 h-3" />;
        case Status.DONE:
          return <CheckCircle2 className="w-3 h-3" />;
        case Status.TODO:
          return <Circle className="w-3 h-3" />;
        case Status.CANCELLED:
          return <XCircle className="w-3 h-3" />;
        case Status.BACKLOG:
          return <CircleDot className="w-3 h-3" />;
        case Status.ACTIVE:
          return <CheckCircle2 className="w-3 h-3" />;
        case Status.ON_LEAVE:
          return <Clock className="w-3 h-3" />;
        default:
          return <CircleDot className="w-3 h-3" />;
      }
    }
  };

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium border ${getStatusStyles()}`}
    >
      <span className="text-xs">{getIcon()}</span>
      {status}
    </span>
  );
};

export default StatusChip;
